import styled from 'styled-components'

import { TypeStyle, timingDefault } from '@syconium/little-miss-figgy'

export const EmbroideryCta = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 40px;
  padding: 0 20px 0 16px;
  border: 1px solid ${o => o.theme.color.deprecated.stone};
  border-radius: 4px;
  transition-duration: ${timingDefault};
  transition-timing-function: ease;

  &:hover {
    background-color: ${o => o.theme.color.deprecated.stoneLighter};
  }
`

export const CtaText = styled(TypeStyle.BodyNano)`
  font-weight: bold;
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const RightSideContent = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`
